module.exports = __webpack_public_path__ + "img/order_image2.f4c542d0.jpg";